import type { TSong } from '@modules/types'
import { useShareModalContext } from '../contexts/shareModal'

export const useShareModal = () => {
  const { handleOpen } = useShareModalContext()

  const openShareModal = (
    songs: TSong[],
    requestId?: number,
    requestTitle?: string,
    distributionTerritory?: string,
    plannedPublicationDate?: string,
  ) => {
    handleOpen(songs, requestId, requestTitle, distributionTerritory, plannedPublicationDate)
  }

  return {
    openShareModal,
  }
}
